import { useAddCommentFeature } from '@features';
import { useState } from 'react';
import { Box, Button, Input, InputGroup, Tooltip } from '@chakra-ui/react';

import { Notes } from '@rta/rta-blueprint-library';

export const CommentsItemizedContentAddComment = (props: { notes: Notes }) => {
	const { notes } = props;
	const [commentText, setCommentText] = useState<string>('');

	const addComment = useAddCommentFeature({ commentText });
	const handleSubmitComment = () => {
		if (!commentText.trim()) return;
		addComment.handler();
		setCommentText('');
	};

	return (
		<Box textAlign="center" marginTop="5px" borderTop={'1px'} pt={'10px'}>
			<InputGroup size="sm" width="100%" mb={2}>
				<Input
					type="text"
					value={commentText}
					onChange={(e) => setCommentText(e.target.value)}
					placeholder="Type a comment..."
					onKeyPress={(e) => e.key === 'Enter' && handleSubmitComment()}
				/>
			</InputGroup>

			<Tooltip label={addComment.tooltip}>
				<Button
					onClick={handleSubmitComment}
					disabled={addComment.disabled || !commentText.trim()}
				>
					{addComment.label}
				</Button>
			</Tooltip>
		</Box>
	);
};
